"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EcomFilter2 = exports.PRODUCT_ATTRIBUTES_SELECT = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const utils_1 = require("@obvio/utils");
const ActionsWrap = app_1.styled.div `
  margin-top: ${(theme) => theme.spacing.extraLarge};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  bottom: 0;
  background: white;
`;
const Content = (0, app_1.styled)(ui_1.Grid) `
  padding: ${(theme) => theme.spacing.medium};
`;
const AccordionWrap = app_1.styled.div `
  flex: 1;
`;
exports.PRODUCT_ATTRIBUTES_SELECT = {
    title: true,
    values: {
        value: true,
    },
};
function EcomFilter2({ onSubmit, onClear, }) {
    const { t } = (0, app_1.useTranslation)();
    const { setQuery, query } = (0, app_1.useRouter)();
    const { data } = (0, app_1.useQuery)('getAllProductAttributes', {
        select: exports.PRODUCT_ATTRIBUTES_SELECT,
    });
    if (!data) {
        return null;
    }
    const handleSubmit = (attributes) => __awaiter(this, void 0, void 0, function* () {
        const params = Object.entries(attributes).reduce((acc, [key, value]) => {
            if (!value) {
                return acc;
            }
            const [k, v] = key.split('-');
            return Object.assign(Object.assign({}, acc), { [k]: acc[k] ? `${acc[k]},${v}` : v });
        }, {});
        yield setQuery(params);
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
        return ui_1.SubmitState.DO_NOT_CLEAR;
    });
    const handleClear = () => __awaiter(this, void 0, void 0, function* () {
        const queryWithoutAttributes = Object.fromEntries(Object.entries(query).filter(([key]) => !data.some((v) => v.title === key)));
        yield setQuery(queryWithoutAttributes);
        onClear === null || onClear === void 0 ? void 0 : onClear();
    });
    const selected = Object.entries(query).reduce((acc, [key, value]) => (value ? Object.assign(Object.assign({}, acc), { [key]: value === null || value === void 0 ? void 0 : value.split(',') }) : acc), {});
    return ((0, jsx_runtime_1.jsxs)(ui_1.Form, Object.assign({ onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(AccordionWrap, { children: (0, jsx_runtime_1.jsx)(ui_1.Accordion, { children: data === null || data === void 0 ? void 0 : data.map((attribute) => ((0, jsx_runtime_1.jsx)(ui_1.Accordion.Element, Object.assign({ title: (0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span" }, { children: attribute.title })) }, { children: (0, jsx_runtime_1.jsx)(Content, Object.assign({ templateColumns: "1fr 1fr", gap: "small" }, { children: attribute.values.map((value) => {
                                var _a;
                                return ((0, jsx_runtime_1.jsx)(ui_1.CheckboxInput, { name: `${attribute.title}-${value.value}`, label: (0, utils_1.capitalize)(value.value), defaultValue: (_a = selected[attribute.title]) === null || _a === void 0 ? void 0 : _a.includes(value.value) }, value.id));
                            }) })) }), attribute.id))) }) }), (0, jsx_runtime_1.jsx)(ui_1.FormContext, { children: ({ getInputs, setValue }) => {
                    const uncheckAll = () => {
                        var _a;
                        Object.keys((_a = getInputs()) !== null && _a !== void 0 ? _a : {}).forEach((input) => setValue(input, false));
                        void handleClear();
                    };
                    return ((0, jsx_runtime_1.jsxs)(ActionsWrap, { children: [(0, jsx_runtime_1.jsx)(ui_1.Submit, Object.assign({ kind: "transparent" }, { children: t('label.FiltersShowResult') })), (0, jsx_runtime_1.jsx)(ui_1.Button, Object.assign({ kind: "transparent", onClick: uncheckAll }, { children: t('label.clearFliters') }))] }));
                } })] })));
}
exports.EcomFilter2 = EcomFilter2;
